import React, { FC } from 'react'
import dynamic from 'next/dynamic'
import noSSR from 'components/DynamicLoader'
import CarouselConnector, { ConnectorProps as CarouselProps } from '../connectors/CarouselABTest'
import { NOT_FOR_SALE } from '../helpers/constants'

const ABArtistArtworksCarousel = dynamic(
  import('../components/Carousels/ABTest/ArtistArtworks'),
  noSSR
)
const ABRelatedArtworksCarousel = dynamic(
  import('../components/Carousels/ABTest/RelatedArtworks'),
  noSSR
)
const ABRecommendedArtworksCarousel = dynamic(
  import('../components/Carousels/GoogleRecommended/pdp'),
  noSSR
)

type CarouselsProps = CarouselProps & {
  shouldLoadComponent: boolean
  setShouldLoadComponent
}

const Carousels: FC<CarouselsProps> = ({
  shouldLoadComponent,
  setShouldLoadComponent,
  productStatus,
}) => {
  const isProductNotForSale = productStatus === NOT_FOR_SALE

  return (
    <>
      <div data-section='artist-carousel'>
        <ABArtistArtworksCarousel setShouldLoadComponent={setShouldLoadComponent} />
      </div>
      <div data-section='rec-carousel' data-style={isProductNotForSale ? '' : 'change-order'}>
        <ABRecommendedArtworksCarousel
          shouldLoadComponent={isProductNotForSale ? true : shouldLoadComponent}
          setShouldLoadComponent={setShouldLoadComponent}
        />
      </div>
      <div data-section='visii-carousel'>
        <ABRelatedArtworksCarousel
          shouldLoadComponent={shouldLoadComponent}
          setShouldLoadComponent={setShouldLoadComponent}
        />
      </div>
    </>
  )
}

export default CarouselConnector(Carousels)
